const destinations = [
  { name: "United Kingdom", context: "London banking and financial services meetings; Hoover corporate executives attending client conferences in London and Edinburgh", urgency: "Financial services trips often booked with 1–2 weeks notice when deal timelines accelerate", icon: "ri-map-pin-2-line" },
  { name: "Germany", context: "Mercedes-Benz USA headquarters interactions; automotive supply chain travel; Hoover engineering and manufacturing professionals", urgency: "Mercedes headquarters visits and supplier meetings organized with short notice", icon: "ri-map-pin-2-line" },
  { name: "Sub-Saharan Africa", context: "Hoover and Vestavia Hills mission teams to Uganda, Kenya, Ethiopia, and South Africa; international adoption travel", urgency: "Mission trip departures and adoption travel windows are non-negotiable", icon: "ri-map-pin-2-line" },
  { name: "Europe (Cruise & Tourism)", context: "Mediterranean cruises, European river cruises, family heritage tourism to Ireland, Italy, and Germany from Hoover families", urgency: "Family cruise bookings made during promotional windows — passport issues discovered late", icon: "ri-map-pin-2-line" },
  { name: "Caribbean & Mexico", context: "Family beach vacations, resort trips, and cruise departures from New Orleans and Tampa connecting from BHM", urgency: "Spring break and summer family travel creates compressed passport timelines", icon: "ri-map-pin-2-line" },
  { name: "Canada", context: "Business travel to Toronto and Montreal; healthcare conference travel for UAB-affiliated physicians; family leisure travel", urgency: "Healthcare conference calendars are set months out but passport checks happen last-minute", icon: "ri-map-pin-2-line" },
];

const stats = [
  { stat: "15 min", label: "from Hoover to Birmingham-Shuttlesworth Airport — BHM's convenience accelerates last-minute booking decisions" },
  { stat: "2–3 Wks", label: "typical notice Hoover executives have when international business trips are confirmed" },
  { stat: "Hundreds", label: "of Hoover and Vestavia Hills church volunteers travel internationally each year for mission trips" },
  { stat: "Top 5", label: "Alabama city by per-capita income — Hoover travelers go international more frequently than most AL residents" },
];

export default function HooverDestinationsSection() {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Local Travel Intelligence</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Where Hoover Travelers Go — And Why Passports Get Urgent
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            These are the destinations and travel patterns we see most from Hoover and Greater Birmingham south suburb clients. Understanding this community's executive, medical, and ministry travel helps us catch document issues before they derail important trips.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-14">
          {stats.map((s, i) => (
            <div key={i} className="bg-[#1A365D] rounded-lg p-6 text-center">
              <p className="font-serif text-3xl font-bold text-[#F6C344] mb-2">{s.stat}</p>
              <p className="text-white/60 text-xs leading-relaxed">{s.label}</p>
            </div>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-12">
          {destinations.map((d, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-200 hover:border-[#F6C344] transition-all group">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#1A365D]/5 group-hover:bg-[#F6C344]/15 transition-colors flex-shrink-0">
                  <i className={`${d.icon} text-[#1A365D] group-hover:text-[#F6C344] transition-colors text-lg`}></i>
                </div>
                <h3 className="font-bold text-[#1A365D] text-sm">{d.name}</h3>
              </div>
              <p className="text-gray-500 text-sm leading-relaxed mb-3">{d.context}</p>
              <div className="flex items-start gap-2">
                <i className="ri-time-line text-[#F6C344] text-xs flex-shrink-0 mt-0.5"></i>
                <p className="text-gray-400 text-xs leading-relaxed italic">{d.urgency}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-200">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#1A365D]/5 flex-shrink-0">
              <i className="ri-links-line text-[#1A365D] text-xl"></i>
            </div>
            <div className="flex-1">
              <h3 className="font-bold text-[#1A365D] text-sm mb-1">Explore Other Alabama Service Areas</h3>
              <p className="text-gray-500 text-sm leading-relaxed">We serve travelers across Alabama with the same expedited passport processing and document review expertise.</p>
            </div>
            <div className="flex flex-wrap gap-2 flex-shrink-0">
              {[{ name: "Birmingham", href: "/birmingham" }, { name: "Huntsville", href: "/huntsville" }, { name: "Tuscaloosa", href: "/tuscaloosa" }].map((link) => (
                <a key={link.href} href={link.href} className="inline-flex items-center gap-1.5 bg-white hover:bg-[#1A365D] text-[#1A365D] hover:text-white border border-gray-200 hover:border-[#1A365D] font-medium text-xs px-3.5 py-2 rounded-md transition-all whitespace-nowrap">
                  {link.name} <i className="ri-arrow-right-line text-xs"></i>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}